/**
 * 📦 V2 Plans API client
 * Rotas /api/v2/plans
 *
 * V2.1: "plano = kit" — composto por 1+ produtos físicos via plan_items.
 */

import v2Api from './index';

export const plansV2API = {
  /**
   * Cria plano + items numa única transação.
   * Body: {
   *   product_id, name, description?, price_cents,
   *   payment_methods: string[],  // ['credit_card','pix','boleto']
   *   installments_max: 1..12,
   *   is_active?: bool,
   *   items: [{ physical_product_id, quantity, display_order? }]
   * }
   */
  create: (data) => v2Api.post('/plans', data),

  listByProduct: (productId) => v2Api.get(`/plans/by-product/${productId}`),

  findById: (id) => v2Api.get(`/plans/${id}`),
  findByUuid: (uuid) => v2Api.get(`/plans/uuid/${uuid}`),

  update: (id, data) => v2Api.patch(`/plans/${id}`, data),
  remove: (id) => v2Api.delete(`/plans/${id}`),
};

export default plansV2API;
